import React,{useState} from 'react';
import styled from 'styled-components'
const Wrapper = styled.div`
    .button {
        color: #000;
        background-color: #fff;
        font-size: 22px;
        border-radius: 999px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 32px;
        min-width: 144px;
        transition: background-color 0.15s linear;
        margin-top: 40px;
        font-weight: 700;
    }
`
const Connect = (props) => {
    const [isConnecting, setIsConnecting] = useState(false);

    const detectProvider = () => {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No Ethereum browser detected! Check out MetaMask");
      }
      return provider;
    };
  
    const onLoginHandler = async () => {
      const provider = detectProvider();
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum provider. Do you have multiple wallet installed ?"
          );
        }
        setIsConnecting(true);
        await provider.request({
          method: "eth_requestAccounts",
        });
        setIsConnecting(false);
      }
      props.onLogin(provider);
    };
    return (
        <Wrapper>
            <button type="button" className="button" button onClick={onLoginHandler}>
            {!isConnecting && "Connect"}
            {isConnecting && "Loading..."}
            </button>
        </Wrapper>
    );
};

export default Connect;